import { ReactSVG } from "react-svg";
import { Table } from "react-bootstrap";
import srxlogowithtext from "../../../assets/images/SRX-logo-with-text.svg";
import exporticon from "../../../assets/images/export-icon.svg";
import useInventory from "../../../Hooks/useInventory";
import { useEffect, useState } from "react";
import moment from "moment";
import Loading from "../../../components/LoadingPage/Loading";
import { currencyFormatter } from "../../../utils/commonUtils";
import { useAppSelector } from "../../../redux/hooks";
import { selectedInventoryItem } from "../../../redux/inventory/inventorySlice";
import { useNavigate } from "react-router-dom";
import "./inventoryTransactionReport.scss";

const InventoryTransactionReport = () => {
  const selectedItem = useAppSelector(selectedInventoryItem);
  const navigate = useNavigate();
  const [TrReportData, setTrReportData] = useState<any>([]);
  const {
    inventoryTransactionsAPI,
    inventoryTransactionsLoading,
    exportInventoryTransactionsAPI,
    invTransactionsExportLoading,
  } = useInventory();

  useEffect(() => {
    if (!selectedItem?.rxSRXId) {
      navigate("/inventory");
      return;
    }
    inventoryTransactionsAPI(selectedItem.rxSRXId)
      .then((res) => {
        if (res && res[0]) {
          setTrReportData(res[0]);
        }
      })
      .catch(() => { });
  }, []);

  const getTotal = () => {
    let sum = 0;
    TrReportData?.reportData?.forEach((x: any) => {
      sum = sum + parseFloat(x.transQty);
    });
    return parseFloat(sum.toString());
  };

  const exportReport = async () => {
    const response = await exportInventoryTransactionsAPI({
      rxSRXId: selectedItem.rxSRXId,
    });
    const url = URL.createObjectURL(response);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${localStorage.getItem("profileClientId")?.toUpperCase()?? ""}_Inventory_Transaction_Report_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div className="inventory-transaction-report-page">
      {inventoryTransactionsLoading || invTransactionsExportLoading ? (
        <Loading />
      ) : null}
      <div className="trans-report-page-header">
        <div className="header-left">
          <span className="back-btn" onClick={() => navigate(-1)}>
            <i className="bi bi-arrow-left"></i>
          </span>
          <h4>Transaction Report</h4>
        </div>
        {TrReportData?.reportData?.length ? (
          <div className="report-export-box">
            <button
              type="button"
              className="report-export-btn"
              onClick={exportReport}
            >
              <ReactSVG className="svg-box" wrapper="span" src={exporticon} />
              Export
            </button>
          </div>
        ) : null}
      </div>
      <div className="trans-report-page-body">
        <div className="trans-report-content-wrapper">
          <div className="trans-report-content-header">
            <div className="header-content">
              <h5>Transaction Report</h5>
              <p>{TrReportData?.subTitleReport}</p>
            </div>
            <div className="header-logo-wrapper">
              <div className="header-logo-box srx-logo-box">
                <img src={srxlogowithtext} alt="srx" />
              </div>
              <div className="header-logo-box sf-logo-box">
                <img
                  src={TrReportData?.clientImage + `?ts=${Date.now()}`}
                  alt="img"
                />
              </div>
            </div>
          </div>
          <div className="trans-report-detail-box-wrapper">
            <h5>{TrReportData?.rxName || selectedItem?.rxName}</h5>

            <div
              className="trans-report-detail-box-container"
              style={{ overflow: "auto" }}
            >
              <div className="trans-report-detail-box">
                <label>SRX Barcode</label>
                <p>{TrReportData?.rxSRXId || selectedItem?.rxSRXId || "-"}</p>
              </div>
              <div className="trans-report-detail-box">
                <label>Manufacturer</label>
                <p>{TrReportData?.manufacturer || selectedItem?.manufacturer || "-"}</p>
              </div>
              <div className="trans-report-detail-box">
                <label>NDC</label>
                <p>{TrReportData?.ndcCode || selectedItem?.ndcCode || "-"}</p>
              </div>
              <div className="trans-report-detail-box">
                <label>LOT No.</label>
                <p>{TrReportData?.lotNo || selectedItem?.lotNo || "-"}</p>
              </div>
              <div className="trans-report-detail-box">
                <label>Exp.Date</label>
                <p>
                  {TrReportData?.expiryDate
                    ? moment(TrReportData?.expiryDate).format("MM/DD/YYYY")
                    : selectedItem?.expiryDate
                      ? moment(selectedItem?.expiryDate).format("MM/DD/YYYY")
                      : "-"}
                </p>
              </div>
            </div>

            <div
              className="trans-report-table-wrapper"
              style={{ overflow: "auto" }}
            >
              <Table bordered={false} hover={true}>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Trans.Type</th>
                    <th>Ref. No</th>
                    <th>user</th>
                    <th>location</th>
                    <th>Qty.</th>
                    <th>Current qty.</th>
                    <th>price</th>
                    <th>trans.value</th>
                    <th>current value</th>
                  </tr>
                </thead>
                <tbody>
                  {TrReportData?.reportData?.length ? (
                    TrReportData?.reportData?.map(
                      (report: any, index: number) => (
                        <tr key={index}>
                          <td>
                            {report.createdOnUtc ? report.createdOnUtc : "NA"}
                          </td>
                          <td>{report.transactionName}</td>
                          <td>{report.referenceNumber}</td>
                          <td>{report.userName}</td>
                          <td>{report.locationName}</td>
                          <td style={{ textAlign: "right" }}>
                            {parseFloat(report.transQty)}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {parseFloat(report.currentQty)}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {currencyFormatter(report.price)}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {currencyFormatter(report.transactionValue)}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {currencyFormatter(report.currentValue)}
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center" }}>
                        No transaction data found
                      </td>
                    </tr>
                  )}
                  <tr>
                    <th colSpan={5}>Total</th>
                    <th colSpan={5} style={{ fontSize: "14px" }}>
                      {getTotal()}
                    </th>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryTransactionReport;
